

































































































































































































































































import { Component, Mixins } from "vue-property-decorator";
import { ContractsModule } from "@/store/contracts.module";
import { ContractIdValidatorMixin } from "@/mixins/ContractIdValidatorMixin";
import { ContractInfo } from "~/contractinfo.type";
import { translate } from "@/utils";
import { Limit } from "~/limit.type";
import moment from "moment";
import ExpansionPanel from "@/components/ui/ExpansionPanel.vue";

@Component({
  components: { ExpansionPanel },
})
export default class ContractView extends Mixins(ContractIdValidatorMixin) {
  getMonthName(name: string): string {
    const r = moment()
      .locale("ru")
      .month(name)
      .format("M");
    const retName: string = moment()
      .locale(this.$i18n.locale)
      .month(parseInt(r) - 1)
      .format("MMMM");
    return retName;
  }

  get get1e() {
    const year: number = new Date().getFullYear();
    const x = this.$t("contractInfo.1e", { year: year });
    return x;
  }

  get getLimits(): Limit[] {
    return ContractsModule.contractLimits;
  }

  get infoLoading(): boolean {
    return ContractsModule.infoIsLoading;
  }

  get getInfo(): ContractInfo {
    return translate(ContractsModule.contractInfo);
  }

  async mounted() {
    await this.validateContractId();
  }
}
